module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/theme-1-1041b4028e7f1db71dcc11b9144673cc.webp";